"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.loadingOverlay = exports.plotOverlayConfig = exports.overlayConfig = exports.paginationSizeSelector = exports.paginationButton = exports.paginationIcons = exports.paginationText = exports.defaultProps = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrapTableNext = _interopRequireDefault(require("react-bootstrap-table-next"));

var _reactBootstrapTable2Overlay = _interopRequireDefault(require("react-bootstrap-table2-overlay"));

var _icon = require("../icon/icon");

require("./table.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultProps = {
  bootstrap4: true,
  bordered: false,
  hover: true,
  striped: true,
  condensed: true,
  className: 'table-borderless',
  noDataIndication: function noDataIndication() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex align-items-center justify-content-center",
      style: {
        minHeight: '60px'
      }
    }, "No data");
  }
};
exports.defaultProps = defaultProps;

var paginationText = function paginationText() {
  var singular = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variant';
  var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'variants';
  return function (from, to, size) {
    return size > 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "react-bootstrap-table-pagination-total ml-2 small text-muted"
    }, "Showing\xA0", 1 + to - from < size && "".concat(from, " to ").concat(to, " of "), size.toLocaleString(), size === 1 ? " ".concat(singular) : " ".concat(plural || singular + 's')) : null;
  };
};

exports.paginationText = paginationText;
var paginationIcons = {
  firstPageText: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "angle-double-left",
    alt: "first page",
    width: "16",
    height: "10"
  }),
  lastPageText: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "angle-double-right",
    alt: "last page",
    width: "16",
    height: "10"
  }),
  prePageText: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "angle-left",
    alt: "previous page",
    width: "16",
    height: "10"
  }),
  nextPageText: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "angle-right",
    alt: "next page",
    width: "16",
    height: "10"
  })
};
exports.paginationIcons = paginationIcons;

var paginationButton = function paginationButton(_ref) {
  var page = _ref.page,
      active = _ref.active,
      disabled = _ref.disabled,
      title = _ref.title,
      onPageChange = _ref.onPageChange;
  var icons = {
    'first page': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "angle-double-left",
      alt: "first page",
      width: "16",
      height: "12"
    }),
    'last page': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "angle-double-right",
      alt: "last page",
      width: "16",
      height: "12"
    }),
    'next page': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "angle-right",
      alt: "next page",
      width: "16",
      height: "12"
    }),
    'previous page': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "angle-left",
      alt: "previous page",
      width: "16",
      height: "12"
    })
  };

  var content = icons[title] || /*#__PURE__*/_react.default.createElement("span", null, title);

  return /*#__PURE__*/_react.default.createElement("li", {
    className: ['page-item', active ? 'active' : 'text-muted'].join(' '),
    onClick: function onClick(e) {
      return onPageChange(page);
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "page-link d-flex align-items-center h-100",
    style: {
      border: 'none',
      fontSize: '0.8rem'
    },
    href: "javascript:void(0)",
    "aria-label": title
  }, content));
};

exports.paginationButton = paginationButton;

var paginationSizeSelector = function paginationSizeSelector(_ref2) {
  var options = _ref2.options,
      currSizePerPage = _ref2.currSizePerPage,
      onSizePerPageChange = _ref2.onSizePerPageChange;
  return /*#__PURE__*/_react.default.createElement("select", {
    className: "form-control-sm",
    value: currSizePerPage,
    onChange: function onChange(e) {
      return onSizePerPageChange(e.target.value);
    },
    "aria-label": "Select a pagination size"
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: option.page,
      value: option.page
    }, option.text);
  }));
};

exports.paginationSizeSelector = paginationSizeSelector;
var overlayConfig = {
  spinner: true,
  styles: {
    spinner: function spinner(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        marginTop: '10px',
        width: '40px',
        '& svg circle': {
          stroke: '#888'
        }
      });
    },
    wrapper: function wrapper(base) {
      return _objectSpread({}, base);
    },
    overlay: function overlay(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        background: 'rgba(255, 255, 255, 0.4)'
      });
    }
  }
};
exports.overlayConfig = overlayConfig;
var plotOverlayConfig = {
  spinner: true,
  styles: _objectSpread(_objectSpread({}, overlayConfig.styles), {}, {
    wrapper: function wrapper(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        position: 'absolute',
        width: '100%',
        height: '100%'
      });
    }
  })
};
exports.plotOverlayConfig = plotOverlayConfig;
var loadingOverlay = (0, _reactBootstrapTable2Overlay.default)(overlayConfig);
exports.loadingOverlay = loadingOverlay;

var Table = function Table(props) {
  props.columns.forEach(function (c) {
    if (c.sort) {
      var sortIcon = function sortIcon(order) {
        switch (order) {
          case 'asc':
            return 'sort-up';

          case 'desc':
            return 'sort-down';

          default:
            return 'sort';
        }
      };

      c.sortCaret = function (order) {
        return /*#__PURE__*/_react.default.createElement(_icon.Icon, {
          name: sortIcon(order),
          alt: "sort icon",
          width: "10",
          height: "16",
          className: "ml-1"
        });
      };
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactBootstrapTableNext.default, _extends({}, defaultProps, props));
};

exports.Table = Table;